import { createContext } from "react";
import SaleItem from "../../../../utilities/data/model/SaleItem";

export type ActiveCartItemContextType = {
  item: SaleItem;
};

export const ActiveCartItemContext = createContext<
  ActiveCartItemContextType | undefined
>(undefined);
